import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Spinner, Text, TextField, Select } from "@shopify/polaris";
import { cross } from "../../../../src/assets";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Contactusapi } from "../../../sellers_module/services/seller/api";
import ReCAPTCHA from "react-google-recaptcha";
import { Modal } from "@mui/material";

const Contactus: React.FC<Contactus> = ({
  open,
  onClose,
  onError,
  viewType,
}) => {
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [appName, setAppName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [discussionTopic, setDiscussionTopic] = useState("");
  const [userType, setUserType] = useState("Company");
  const [captchaValue, setCaptchaValue] = useState("");
  const [disabled, setDisabled] = useState(true);

  const [firstNameError, setFirstNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [companyNameError, setCompanyNameError] = useState("");
  const [discussionTopicError, setDiscussionTopicError] = useState("");
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  useEffect(() => {
    // Disable the submit button if any required field is empty or captcha is not ticked
    if (
      !firstName ||
      !emailPattern.test(email) ||
      phoneNumber.length !== 10 ||
      !discussionTopic ||
      (userType === "Company" && !companyName) ||
      !captchaValue
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [
    firstName,
    email,
    phoneNumber,
    discussionTopic,
    userType,
    companyName,
    captchaValue,
  ]);

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleSave = async () => {
    let valid = true;

    // Reset errors
    setFirstNameError("");
    setEmailError("");
    setPhoneNumberError("");
    setCompanyNameError("");
    setDiscussionTopicError("");

    if (!firstName || firstName.length < 3) {
      setFirstNameError("Name must be at least 3 characters long");
      valid = false;
    }
    if (!email) {
      setEmailError("Email is required");
      valid = false;
    }
    if (userType === "Company" && !companyName) {
      setCompanyNameError("Company name is required for company users");
      valid = false;
    }
    if (!phoneNumber || phoneNumber.length !== 10) {
      setPhoneNumberError("Phone number must be 10 digits long");
      valid = false;
    }
    if (!discussionTopic) {
      setDiscussionTopicError("Description is required");
      valid = false;
    }
    if (!captchaValue) {
      onError("Please complete the CAPTCHA");
      valid = false;
    }

    if (!valid) {
      onError("Please fill in all the details correctly");
      return;
    }

    setLoading(true);
    try {
      const ContactusData = {
        name: firstName,
        email: email,
        user_type: userType,
        company_name: companyName,
        phone_number: "+91" + phoneNumber,
        app_name: appName,
        description: discussionTopic,
      };

      const res = await Contactusapi(ContactusData);

      if (res.data.status_code === 200) {
        handleClose();
        window.scrollTo({ top: 0, behavior: 'smooth' }); 
        toast.success("Details Submitted Successfully");
      } else {
        console.error("Unexpected or failed response:", res);
        onError("Unexpected or failed response");
      }
    } catch (error) {
      console.error("Error submitting The query:", error);
      onError("Error submitting The query:");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFirstName("");
    setAppName("");
    setEmail("");
    setPhoneNumber("");
    setCompanyName("");
    setDiscussionTopic("");
    onClose();
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div
          style={{
            boxShadow: " 0px 2px 10px #DDE0FF80",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: "20px",
            outline: "none",
            borderRadius: "10px",
          }}
        >
          <div
            style={{ position: "absolute", top: 0, right: 0, padding: "5px" }}
          >
            <img
              style={{ width: "40px", cursor: "pointer" }}
              src={cross}
              alt="Close Icon"
              onClick={handleClose}
            />
          </div>

          <div
            style={{
              width: viewType === "tab" ? "350px" : "500px",
              padding: "10px",
            }}
          >
            <Text variant="headingXl" as="h4">
              Join Shiprocket App Store
            </Text>
            <p
              style={{
                marginBottom: "16px",
                textAlign: "left",
                color: "#000000E6",
                opacity: 1,
              }}
            >
              Ready to expand your app’s reach? Fill out the form below to
              express your interest in listing your app on our platform.
            </p>
            <div
              style={{
                display: "flex",
                marginBottom: "16px",
                borderRadius: "4px",
              }}
            >
              <div style={{ width: "50%", marginRight: "4%" }}>
                <TextField
                  placeholder="Full Name"
                  label={
                    <>
                      <span
                        style={{
                          font: "normal normal medium 12px/16px SF Pro Display",
                        }}
                      >
                        Name
                      </span>
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  maxLength={32}
                  autoComplete="off"
                  value={firstName}
                  onChange={(newValue) => {
                    setFirstName(newValue);
                    setFirstNameError("");
                  }}
                  error={firstNameError}
                />
              </div>
              <div style={{ width: "50%" }}>
                <TextField
                  placeholder="Email"
                  label={
                    <>
                      <span
                        style={{
                          font: "normal normal medium 12px/16px SF Pro Display",
                        }}
                      >
                        Email
                      </span>
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  autoComplete="off"
                  value={email}
                  type="email"
                  onChange={(newValue) => {
                    setEmail(newValue);
                    setEmailError("");
                  }}
                  error={emailError}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                borderRadius: "4px",
              }}
            >
              <div style={{ width: "50%", marginRight: "4%" }}>
                <TextField
                  placeholder="Contact Number"
                  maxLength={10}
                  label={
                    <>
                      <span
                        style={{
                          font: "normal normal medium 12px/16px SF Pro Display",
                        }}
                      >
                        Phone Number
                      </span>
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  autoComplete="off"
                  prefix="+91"
                  value={phoneNumber}
                  onChange={(newValue) => {
                    if (/^\d*$/.test(newValue)) {
                      setPhoneNumber(newValue);
                      setPhoneNumberError("");
                    }
                  }}
                  error={phoneNumberError}
                />
              </div>

              <div
                style={{
                  marginBottom: "16px",
                  borderRadius: "4px",
                  width: "50%",
                }}
              >
                <Select
                  label={
                    <>
                      <span
                        style={{
                          font: "normal normal medium 12px/16px SF Pro Display",
                        }}
                      >
                        Type
                      </span>
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  options={[
                    { label: "Company", value: "Company" },
                    { label: "Individual", value: "Individual" },
                    { label: "Student", value: "Student" },
                  ]}
                  value={userType}
                  onChange={(newValue) => setUserType(newValue)}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                marginBottom: "16px",
                borderRadius: "4px",
              }}
            >
              <div style={{ width: "50%", marginRight: "4%" }}>
                <TextField
                  placeholder="Company Name"
                  maxLength={32}
                  label={
                    <>
                      <span
                        style={{
                          font: "normal normal medium 12px/16px SF Pro Display",
                        }}
                      >
                        Company Name
                      </span>
                      {userType === "Company" && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </>
                  }
                  autoComplete="off"
                  value={companyName}
                  onChange={(newValue) => {
                    setCompanyName(newValue);
                    setCompanyNameError("");
                  }}
                  error={companyNameError}
                />
              </div>
              <div style={{ width: "50%" }}>
                <TextField
                  placeholder="App Name"
                  maxLength={32}
                  label={
                    <span
                      style={{
                        font: "normal normal medium 12px/16px SF Pro Display",
                      }}
                    >
                      App Name
                    </span>
                  }
                  autoComplete="off"
                  value={appName}
                  onChange={(newValue) => setAppName(newValue)}
                />
              </div>
            </div>

            <div
              style={{
                borderRadius: "4px",
                marginBottom: "20px",
              }}
            >
              <TextField
                label={
                  <>
                    <span
                      style={{
                        font: "normal normal medium 12px/16px SF Pro Display",
                      }}
                    >
                      App Brief Description{" "}
                    </span>
                    <span style={{ color: "red" }}>*</span>
                  </>
                }
                placeholder="A short description"
                autoComplete="off"
                multiline={2}
                maxLength={250}
                showCharacterCount
                value={discussionTopic}
                onChange={(newValue) => {
                  setDiscussionTopic(newValue);
                  setDiscussionTopicError("");
                }}
                error={discussionTopicError}
              />
            </div>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={handleCaptchaChange}
            />
          </div>

          <div
            style={{
              textAlign: "center",
              width: "100%",
              marginTop: "20px",
              opacity: disabled ? 0.5 : 1,
            }}
          >
            {loading ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Spinner size="small" />
              </div>
            ) : (
              <button
                style={{
                  font: "normal normal medium 14px/41px SF Pro Display",
                  border: "1px solid 7F60DC",
                  borderRadius: "4px",
                  padding: "10px 20px",
                  backgroundColor: "#7F60DC",
                  color: "white",
                  cursor: "pointer",
                  outline: "none",
                  width: "100%",
                }}
                onClick={handleSave}
                disabled={!captchaValue || disabled}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

// Define PropTypes for the component
interface Contactus {
  open: boolean;
  onClose: () => void;
  onError: any;
  viewType: string;
}
export default Contactus;
